import { useContext, useEffect, useRef, useState } from "react";
import useStore from "../../../../context/useStore";
import RichInputEditor from "../../RichInputEditor/RichInputEditor";
import { CommentCreatedBy } from "../common/CommentCreatedBy/CommentCreatedBy";
import CommentNameView from "../common/CommentNameView/CommentNameView";
import { CommentContext } from "../context/CommentContext";
import { peutModifierCommentaire } from "../droitsCommentaire";

// Un commentaire : en-tête (avatar, auteur, date, mention « modifié »), texte,
// puis « Modifier » et « Supprimer » pour son auteur ou un administrateur.
// La modification se fait en place, dans le même éditeur que la saisie.
const CommentItem = ({ users }) => {
  const { comment, actions } = useContext(CommentContext);
  const [state] = useStore();
  const [edition, setEdition] = useState(false);
  const [rendreFocus, setRendreFocus] = useState(false);
  const refModifier = useRef(null);
  const peutModifier = peutModifierCommentaire(state.auth.user, state.auth.myRole, comment);

  // Le bouton « Modifier » n'est pas dans la page pendant l'édition : le focus
  // lui revient une fois l'éditeur refermé.
  useEffect(() => {
    if (edition || !rendreFocus) return;
    if (refModifier.current) refModifier.current.focus();
    setRendreFocus(false);
  }, [edition, rendreFocus]);

  const fermer = () => {
    setEdition(false);
    setRendreFocus(true);
  };
  const enregistrer = (donnees) => {
    actions.updateComment({ ...comment, ...donnees.comment });
    fermer();
  };
  const annuler = fermer;

  return (
    <>
      <CommentCreatedBy comment={comment} avecModification />
      {edition ? (
        <div className="cl-edition">
          <RichInputEditor
            users={users}
            initialComment={comment.text}
            onSubmit={enregistrer}
            onCancel={annuler}
            label="Modifier le commentaire"
            submitLabel="Enregistrer"
            autoFocus
            compact
          />
        </div>
      ) : (
        <CommentNameView comment={comment} />
      )}
      {peutModifier && !edition && (
        <div className="cl-actions">
          <button type="button" ref={refModifier} onClick={() => setEdition(true)}>
            Modifier
          </button>
          <button type="button" className="cl-actions__danger" onClick={() => actions.deleteComment(comment.id)}>
            Supprimer
          </button>
        </div>
      )}
    </>
  );
};

export default CommentItem;
